import { UIElements } from '@ansvar-sakerhet/ui';
import { styled } from 'styled-components';

const TableContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: space-between;
  flex-grow: 1;
`;

const PaginationContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
`;

const DeleteDataCell = styled.td`
  vertical-align: middle;
  font-size: 18px;
  text-align: left;
  font-weight: 300;
  min-width: 210px;
`;

const CenteredIcon = styled(UIElements.Icon)`
  vertical-align: middle;
`;

const ShowBarChartContainer = styled(UIElements.Flex)`
  width: 100%;
  height: 100%;
  min-height: 400px;
  background-color: white;
  padding: 10px;
  padding-top: 25px;
  flex-direction: column;

  @media (min-width: 1350px) {
    width: calc(50% - 5px);
  }
`;

const TableText = styled.p`
  display: inline;
`;

export const S = {
  ...UIElements,
  ShowBarChartContainer,
  TableText,
  CenteredIcon,
  TableContainer,
  PaginationContainer,
  DeleteDataCell,
};
